import React from 'react';

interface IMBTSAxisParameter {
    testing_skill: { short_title: string };
    score: number;
};
export const OrganisationalMastery = () => {
    const parameters: IMBTSAxisParameter[] = [
        { testing_skill: { short_title: 'CURIOUSITY' }, score: 4.4 },
        { testing_skill: { short_title: 'EMPATHY' }, score: 4.8 },
        { testing_skill: { short_title: 'LISTENING' }, score: 3.4 },
        { testing_skill: { short_title: 'SENSE-MAKING' }, score: 2.6 },
        { testing_skill: { short_title: 'ALIGNING' }, score: 3.1 },
    ];

    return (
        <div className='card card--md card--radius-sm dashboard__stats_card__mbts__organisational_mastery'>
            <p className='text-medium'>Organisational Mastery</p>
            <div className="dashboard__stats_card__mbts__organisational_mastery__content">
                <Graph parameters={parameters} />
            </div>
        </div>
    );
};

interface GraphProps {
    parameters: IMBTSAxisParameter[];
};
const Graph = (props: GraphProps) => {
    const { parameters } = props;

    const MAX_SCORE = 5;
    const AXIS_ORDER = parameters.map(p => p.testing_skill.short_title);
    const polarToCartesian = (centerX: number, centerY: number, radius: number, angleRadians: number) => {
        return {
            x: centerX + radius * Math.cos(angleRadians),
            y: centerY + radius * Math.sin(angleRadians),
        };
    };

    const buildPolygonPoints = (oParameters: typeof parameters, maxRadius: number) => {
        const centerX = 50;
        const centerY = 50;
        const angleStep = (2 * Math.PI) / AXIS_ORDER.length;

        return AXIS_ORDER.map((axis, index) => {
            const param = oParameters.find(p => p.testing_skill.short_title === axis);
            const score = param ? param.score : 0;

            const radius = (score / MAX_SCORE) * maxRadius;
            const angle = angleStep * index - Math.PI / 2; // rotate so first axis is top

            const { x, y } = polarToCartesian(centerX, centerY, radius, angle);
            return `${x},${y}`;
        }).join(' ');
    };

    const currentProfilePoints = buildPolygonPoints(parameters, 32);
    const forceMultiplierPoints = buildPolygonPoints(parameters.map(p => ({ ...p, score: 4.5 })), 32);

    return (
        <svg viewBox="-25 -20 150 140" className="dashboard__stats_card__mbts__organisational_mastery__graph">
            {/* Grid */}
            {[10, 20, 30, 40].map(r => <circle key={r} r={r} />)}

            {/* Force Multiplier (L5) */}
            <polygon points={forceMultiplierPoints} className="target" />

            {/* Current Profile */}
            <polygon points={currentProfilePoints} className="current" />

            {/* Axis labels */}
            {AXIS_ORDER.map((label, index) => {
                const angle = (2 * Math.PI / AXIS_ORDER.length) * index - Math.PI / 2;
                const { x, y } = polarToCartesian(50, 50, 45, angle);

                return <text key={label} x={x} y={y}>{label}</text>;
            })}
        </svg>
    );
};